// extracted by mini-css-extract-plugin
export default {"list":"Summary_list__dKE4L","titleItem":"Summary_titleItem__zK8VI","title":"Summary_title__dimK-","item":"Summary_item__St+1w","zeroItem":"Summary_zeroItem__E58Go"};